import { ProductType } from "@exonn/js-sdk";
import type { TFunction } from "i18next";
import { getResourceFieldTranslation } from "src/system/getResourceFieldOptions.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const PRODUCT_TYPES = {
  [ProductType.SINGLE]: {
    icon: <i className="icon-15-single_m" />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.SINGLE,
      }),
  },
  [ProductType.SET]: {
    icon: <i className="icon-15-set_m" />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.SET,
      }),
  },
  [ProductType.MULTIPLE]: {
    icon: <i className="icon-15-variant_m" />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.MULTIPLE,
      }),
  },
  [ProductType.COMPLEX]: {
    icon: <i className="icon-15-variant-set" />,
    title: (t: TFunction) =>
      getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.COMPLEX,
      }),
  },
};
